import { Injectable } from '@angular/core';
import { DOM_SELECTORS, DOM_STYLES } from '../constants';


@Injectable()
export class DomManagerService {
  /**
   * Initializes DOM elements on component init
   */
  initializeDom(): void {
    this.applyHintsHostStyles();
    this.applyHintStyles();
  }

  /**
   * Applies styles to TUI hints host element
   */
  private applyHintsHostStyles(): void {
    const elements = document.getElementsByTagName(DOM_SELECTORS.TUI_HINTS_HOST);
    if (elements[0]) {
      const element = elements[0] as HTMLElement;
      element.style.zIndex = DOM_STYLES.HINTS_Z_INDEX;
    }
  }

  /**
   * Applies styles to TUI hint elements
   */
  private applyHintStyles(): void {
    const elements = document.getElementsByTagName(DOM_SELECTORS.TUI_HINT);
    if (elements[0]) {
      const element = elements[0] as HTMLElement;
      element.style.background = DOM_STYLES.HINT_BACKGROUND;
      element.style.color = DOM_STYLES.HINT_COLOR;
    }
  }

  /**
   * Moves dropdown element to modal container
   * Required for proper z-index layering
   */
  moveDropdownToContainer(): void {
    setTimeout(() => {
      const dropdown = document.querySelector(DOM_SELECTORS.TUI_DROPDOWN);
      const container = document.getElementById(DOM_SELECTORS.MODAL_CONTAINER);
      
      if (dropdown && container) {
        container.innerHTML = '';
        container.appendChild(dropdown);
      }
    }, 200);
  }

  /**
   * Handles select dropdown positioning
   */
  handleSelectClick(selectId: string, clickCounts: { [key: string]: number }): void {
    if (!clickCounts[selectId]) {
      clickCounts[selectId] = 0;
    }
    clickCounts[selectId]++;

    if (clickCounts[selectId] === 1) {
      this.moveDropdownToContainer();
    } else if (clickCounts[selectId] === 2) {
      const selectElement = document.getElementById(selectId) as HTMLSelectElement;
      if (selectElement && document.activeElement === selectElement) {
        selectElement.blur();
      }
      clickCounts[selectId] = 0;
    }
  }

  /**
   * Resets all select click counts
   */
  resetSelectCounts(clickCounts: { [key: string]: number }): void {
    Object.keys(clickCounts).forEach(key => {
      clickCounts[key] = 0;
    });
  }
}
